import { createReducer } from '@reduxjs/toolkit'
import {
  openKlineModal,
  closeKlineModal,
  updateTradingPair,
  setCurrentTradingPair,
  clearTradingPair,
  TradingPair
} from './actions'

export interface KlineState {
  // K线图弹窗是否打开
  isModalOpen: boolean
  // 当前选中的交易对信息
  currentTradingPair: TradingPair | null
}

const initialState: KlineState = {
  isModalOpen: false,
  currentTradingPair: null
}

export default createReducer(initialState, builder =>
  builder
    .addCase(openKlineModal, state => {
      state.isModalOpen = true
    })
    .addCase(closeKlineModal, state => {
      state.isModalOpen = false
    })
    .addCase(setCurrentTradingPair, (state, { payload }) => {
      state.currentTradingPair = payload
    })
    .addCase(updateTradingPair, (state, { payload }) => {
      state.currentTradingPair = payload
    })
    .addCase(clearTradingPair, state => {
      state.currentTradingPair = null
    })
)